import React from "react";
import { CalendarIcon } from "./styled/date-picker";

type Props = {
    onClick: () => void;
    children?: any;
    symbol?: string;
    cssClass?: string;
    isActive?: boolean;
    hideCalendarIcon?: boolean;
};

const DatePickerPostfix = ({
    onClick,
    children,
    symbol = "",
    cssClass = "",
    isActive = false,
    hideCalendarIcon = false
}: Props) => {
    // Assemble className property
    const classNames = ["postfix"];
    cssClass && cssClass.length && classNames.push(cssClass);
    isActive && classNames.push("active");
    hideCalendarIcon && classNames.push("hide-calendar-icon");

    const postFix = !hideCalendarIcon ? (
        <CalendarIcon
            className={`calendar-icon ${isActive && "active"}`}
            title="Calendar icon: click to open or close the calendar"
            onClick={onClick}
        />
    ) : (
        symbol
    );

    return (
        <div className={classNames.join(" ")}>
            {children}
            {postFix}
        </div>
    );
};

export default DatePickerPostfix;
